import { MenuItems } from "Shared/Components/Layout/Full/Sidebar/MenuItems";
import type { MenuItemsType } from "Shared/Components/Layout/Full/Sidebar/Types/MenuItem";
import { Close, Search as SearchIcon } from "@mui/icons-material";
import {
	Box,
	Dialog,
	DialogContent,
	Divider,
	IconButton,
	List,
	ListItemButton,
	ListItemText,
	Stack,
	TextField,
	Typography,
} from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";

export const Search = () => {
	const [showDrawer2, setShowDrawer2] = useState(false);
	const [search, setSerach] = useState("");

	const handleDrawerClose2 = () => {
		setShowDrawer2(false);
	};

	const filterRoutes = (rotr: MenuItemsType[], cSearch: string) => {
		if (rotr.length > 1)
			return rotr.filter((t: MenuItemsType) =>
				t.title && t.href
					? t.href.toLocaleLowerCase().includes(cSearch.toLocaleLowerCase())
					: "",
			);

		return rotr;
	};
	const searchData = filterRoutes(MenuItems, search);

	return (
		<>
			<IconButton
				aria-label="show 4 new mails"
				color="inherit"
				aria-controls="search-menu"
				aria-haspopup="true"
				onClick={() => setShowDrawer2(true)}
				size="large"
			>
				<SearchIcon fontSize="small" />
			</IconButton>
			<Dialog
				open={showDrawer2}
				onClose={() => setShowDrawer2(false)}
				fullWidth
				maxWidth={"sm"}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				PaperProps={{ sx: { position: "fixed", top: 30, m: 0 } }}
			>
				<DialogContent className="testdialog">
					<Stack direction="row" spacing={2} alignItems="center">
						<TextField
							id="tb-search"
							placeholder="Search here"
							fullWidth
							onChange={(e) => setSerach(e.target.value)}
							inputProps={{ "aria-label": "Search here" }}
						/>
						<IconButton size="small" onClick={handleDrawerClose2}>
							<Close fontSize="small" />
						</IconButton>
					</Stack>
				</DialogContent>
				<Divider />
				<Box p={2} sx={{ maxHeight: "60vh", overflow: "auto" }}>
					<Typography variant="h5" p={1}>
						Quick Page Links
					</Typography>
					<Box>
						<List component="nav">
							{searchData.map((menu: MenuItemsType) => {
								return (
									<Box key={menu.title ? menu.id : menu.subheader}>
										{menu.title && !menu.children ? (
											<ListItemButton
												sx={{ py: 0.5, px: 1 }}
												to={menu?.href ?? ""}
												component={Link}
											>
												<ListItemText
													primary={menu.title}
													secondary={menu?.href}
													sx={{ my: 0, py: 0.5 }}
												/>
											</ListItemButton>
										) : (
											""
										)}
										{menu.children ? (
											<>
												{menu.children.map((child: MenuItemsType) => {
													return (
														<ListItemButton
															sx={{ py: 0.5, px: 1 }}
															to={child.href ?? ""}
															component={Link}
															key={child.title ? child.id : menu.subheader}
														>
															<ListItemText
																primary={child.title}
																secondary={child.href}
																sx={{ my: 0, py: 0.5 }}
															/>
														</ListItemButton>
													);
												})}
											</>
										) : (
											""
										)}
									</Box>
								);
							})}
						</List>
					</Box>
				</Box>
			</Dialog>
		</>
	);
};
